import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-sign-out',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './sign-out.component.html',
  styleUrl: './sign-out.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignOutComponent {
  public email: string = '';

  constructor(private authService: AuthService) {
    this.email = this.authService.userEmail;
  }

  public onClickSignOut(): void {
    this.authService.init();
    // 프로덕션 환경에서는 sid.zammy.ai를 그대로 사용
    window.location.href = this.authService.redirectUrl;
  }

  public onClickCancel(): void {
    // 프로덕션 환경에서는 sid.zammy.ai를 그대로 사용
    window.location.href = this.authService.redirectUrl;
  }
}
